<template>
  <div>
    <Form ref="resourceTagForm" :model="resourceTagForm" :rules="ruleValidate">
      <Row :gutter="4" style="margin-bottom: 10px;">
        <div v-if="company == 1">
          <Col span="6">
            <FormItem label="" prop="companyId">
              <Select
                v-model="resourceTagForm.companyId"
                filterable
                :placeholder="$t('alarms.common.pleaseSelectCompany')"
                :transfer="true"
                @on-change="changeCompany"
              >
                <Option
                  :value="item.id"
                  v-for="item in companyList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </div>
        <Col span="6">
          <FormItem label="" prop="accountIds">
            <Select
              v-model="resourceTagForm.accountIds"
              filterable
              multiple
              :max-tag-count="1"
              :placeholder="$t('alarms.common.pleaseSelectAccount')"
              :transfer="true"
              @on-change="changeAccountId"
            >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="" prop="awsResourceType">
            <Select
              v-model="resourceTagForm.awsResourceType"
              :placeholder="$t('tag.pleaseSelectAwsResourceType')"
              :transfer="true"
              @on-change="changeAwsResourceType"
            >
              <Option
                v-for="item in isAwsResourceType"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <Button
            type="primary"
            v-hasPermission="['labelManagement:tag:resource_search']"
            @click="show('resourceTagForm')"
            >{{ $t("alarms.common.search") }}
          </Button>
          <Button
            type="primary"
            v-hasPermission="['labelManagement:tag:export']"
            :loading="modal_loading"
            @click="exportList('resourceTagForm')"
            >{{ $t("common.export") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <table-resource-tag></table-resource-tag>
  </div>
</template>
<script>
import TableResourceTag from "../tag_management/TableResourceTag";
import { getCookie } from "../../../../utils/cookieUtil.js";

let resourceTagSearch = {};
export default {
  name: "ResourceTagSearch",
  components: {
    TableResourceTag
  },
  data() {
    return {
      accountList: [],
      modal_loading: false,
      company: getCookie(global.companyId),
      companyList: [],
      resourceTagForm: {
        accountIds: [],
        companyId: "",
        awsResourceType: null
      },
      isAwsResourceType: [
        {
          id: 0,
          name: "EC2"
        },
        {
          id: 1,
          name: "RDS"
        },
        {
          id: 2,
          name: "Redshift"
        },
        {
          id: 3,
          name: "ElastiCache"
        },
        {
          id: 5,
          name: "Elasticsearch"
        },
        {
          id: 9,
          name: "ELB"
        },
        {
          id: 10,
          name: "S3"
        },
        {
          id: 11,
          name: "EBS"
        }
      ],
      ruleValidate: {
        awsResourceType: [
          {
            required: true,
            message: "请选择AWS资源类型",
            trigger: "change",
            type: "number"
          }
        ],
        companyId: [
          {
            required: true,
            message: "请选择公司",
            trigger: "change",
            type: "number"
          }
        ],
        accountIds: [
          {
            required: true,
            message: "请选择账号",
            trigger: "change",
            type: "array"
          }
        ]
      }
    };
  },
  beforeCreate: function() {
    resourceTagSearch = this;
  },
  mounted() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      this.listAccountsByCompanyIdAndCloudPlatformType();
    }
  },
  methods: {
    clear: function() {
      this.$children[1].tableColumns = [];
      this.$children[1].tableData = [];
      this.$children[1].current = 1;
      this.$children[1].dataTotal = 0;
      this.$children[1].pageSize = 10;
    },
    show: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$children[1].showAll(
            this.resourceTagForm.companyId,
            this.resourceTagForm.accountIds,
            this.resourceTagForm.awsResourceType
          );
        }
      });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 切换公司
    changeCompany: function() {
      this.resourceTagForm.accountIds = [];
      this.listAccountsByCompanyIdAndCloudPlatformType();
      this.clear();
    },
    // 账号
    listAccountsByCompanyIdAndCloudPlatformType: function() {
      this.$api.account
        .listAccountsByCompanyIdAndCloudPlatformType({
          companyId:
            this.resourceTagForm.companyId == null ||
            this.resourceTagForm.companyId == "" ||
            this.resourceTagForm.companyId == undefined
              ? this.company
              : this.resourceTagForm.companyId,
          type: 0
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    // 切换账号
    changeAccountId: function() {
      this.clear();
    },
    // 切换资源
    changeAwsResourceType: function() {
      this.clear();
    },
    //导出
    exportList: function(name) {
      // 下载Excel 文件
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$children[1].selectedCell.rowIndex = "";
          this.$children[1].selectedCell.columnIndex = "";
          this.$children[1].showAll(
            this.resourceTagForm.companyId,
            this.resourceTagForm.accountIds,
            this.resourceTagForm.awsResourceType
          );
          this.modal_loading = true;
          this.$Message.loading({
            duration: 0,
            content: "正在导出，请稍等..."
          });
          this.$api.tag
            .exportResourceTags({
              companyId:
                this.resourceTagForm.companyId == null ||
                this.resourceTagForm.companyId == "" ||
                this.resourceTagForm.companyId == undefined
                  ? this.company
                  : this.resourceTagForm.companyId,
              awsResourceType: this.resourceTagForm.awsResourceType,
              accountIds: this.resourceTagForm.accountIds
            })
            .then(res => {
              let fileName = "资源标签.xls";
              let blob = new Blob([res.data], { type: "application/x-xls" });
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(link.href);
              }
              this.modal_loading = false;
              this.$Message.destroy();
              this.$Message.success("导出成功");
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-form-item {
  margin-bottom: 11px !important;
  vertical-align: top;
  zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/ResourceTagSearch.vue